<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Student Status Report">
        <v-card flat class="px-2">
          <v-row>
            <v-col  cols="12" md="3" sm="4" v-if="isSuperAdmin" class="pl-6 pr-6">
              <label class="font-weight-medium body-2">
              Select Zone <span class="red--text">*</span></label>
              <v-checkbox v-if="zones.length === 4" v-model="flag" @change="allZones"
                label="All Zones"></v-checkbox>

              <multiselect class="overflowmultiselect2" label="name" track-by="name"
                :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                :preselect-first="false" :multiple="true" :options="zones"
                v-model="selectedZones" @remove="removeCheckZone"                 >
                <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single"
                  v-if="values.role && !isOpen">{{ values }} </span>
                </template>
              </multiselect>

            </v-col>
            <v-col cols="12" md="3"  sm="4" class="pr-6">
              <label class="font-weight-medium body-2">Select Center<span class="error--text ml-1">*</span></label>
                <v-checkbox :disabled="selectedZones.length === 4 || selectedZones.length === 0" v-model="flagFranchisee" @change="allFranchisee"
                  label="All Center">
                </v-checkbox>

                <multiselect :disabled="selectedZones.length === 4" class="overflowmultiselect2" label="companyName" track-by="companyName"
                  :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                  :preselect-first="false" :multiple="true" :options="zoneWiseFranchisees"
                  v-model="selectedCenterIds" @remove="removeCheckFranchisee">
                  <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single"
                    v-if="values.role && !isOpen">{{ values.companyName }} </span>
                  </template>
                </multiselect>

            </v-col>
            <v-col cols="12" md="2" sm="4" class="pr-6">
              <label class="font-weight-medium body-2">
              Status </label>
              <v-checkbox v-model="flagStatus" @change="allStatus"
                label="All Status">
              </v-checkbox>

                <multiselect class="overflowmultiselect2" label="label" track-by="label"
                  :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                  :preselect-first="false" :multiple="true" :options="statusOptions"
                  v-model="selectedStatus" @remove="removeCheckStatus">
                  <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single"
                    v-if="values.role && !isOpen">{{ values.label }} </span>
                  </template>
                </multiselect>
            </v-col>

                <v-btn color="success" class="mr-6" @click="getStudents(selectedCenterIds, academicYearID, selectedStatus)">
                  <v-icon left size="18">mdi-text-box-check-outline</v-icon>
                  Submit
                </v-btn>

                <v-btn color="primary" v-if="selectedZones.length !== 4" class="mr-6 " @click="downloadCSV()">
                  <v-icon left>mdi-download</v-icon>
                  Download CSV
                </v-btn>

                  <v-btn color="gray" @click="resetFilters">
                  <v-icon left>mdi-refresh</v-icon>
                  Reset
                </v-btn>
          </v-row>
        </v-card>

        <v-card-component v-if="selectedZones.length !== 4 && processedData.length > 0">
          <v-card-text class="pt-0 pr-1"></v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table  :hide-default-footer="true" :headers="displayedHeaders" :items="processedData" :items-per-page="pageSize" :page.sync="page">
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
          <v-col>
            <v-row>
              <v-col cols="4" sm="3">
                <v-select v-model="pageSize" :items="pageSizes" label="Items per Page" @change="handlePageSizeChange"></v-select>
              </v-col>

              <v-col cols="12" sm="9">
                <v-pagination v-model="page" :length="Math.ceil(processedData.length/pageSize)" :total-visible="10" @input="handlePageChange"></v-pagination>
              </v-col>
            </v-row>
<v-row>
  <v-col cols="8" sm="9" class="d-flex align-center">
                <span class="text-body-1">
                  Showing {{ startIndex }} to {{ endIndex }} out of {{ totalStudent }} students
                </span>
              </v-col>
</v-row>
          </v-col>
        </v-card-component>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
    <template>
  <v-container v-if="selectedZones.length === 4 && processedData.length > 0" class="fill-height d-flex justify-center align-center" style="margin-top: 150px;">
    <v-btn color="primary" class="mr-6" @click="downloadCSV()">
      <v-icon left>mdi-download</v-icon>
      Download CSV
    </v-btn>
  </v-container>
</template>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import { mapGetters } from 'vuex'
import moment from 'moment'
import stores from '@/stores'
import Utils from '@/utils'
import Multiselect from 'vue-multiselect'

export default {
  name: 'parentIEAppReport',
  components: { MaterialCard, Multiselect },
  data () {
    return {
      selectedCenterIds: [],
      selectedStatus: '',
      zones: [],
      zoneWiseFranchisees: [],
      selectedZones: '',
      modules: {
        ViewReportCard: this.checkModuleAccess('ViewReportCard'),
        studentActiveInactive: this.checkModuleAccess('studentActiveInactive')
      },
      students: [],
      activeList: true,
      search: '',
      isTransport: false,
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 20, 40],
      franchiseeID: '',
      franchiseeArr: [],
      isLoading: false,
      totalStudents: 0,
      academicYearID: '',
      academicYears: [],
      isWrite: false,
      headers: [
        { text: 'Sr. No.', value: 'srNo', sortable: false },
        { text: 'Academic Year', value: 'franchisee.franchiseeAcademicYear.academicYear', sortable: false },
        { text: 'Zone', value: 'franchisee.region', sortable: false, align: 'center' },
        { text: 'Center ID', value: 'franchisee.id', sortable: false, align: 'center' },
        { text: 'Center Name', value: 'franchisee.companyName', sortable: false, align: 'center' },
        { text: 'Enrollment ID', value: 'enrollmentCode', sortable: false, align: 'center' },
        { text: 'Student Name', value: 'fullName', sortable: true, align: 'center' },
        { text: 'Father Name', value: 'fatherName', sortable: true, align: 'center' },
        { text: 'Father Status', value: 'fatherLogin', sortable: true, align: 'center' },
        { text: 'Mother Name', value: 'motherName', sortable: true, align: 'center' },
        { text: 'Mother Status', value: 'motherLogin', sortable: false, align: 'center' }
      ],
      statusOptions: [
        { label: 'Active', value: 'active' },
        { label: 'Inactive', value: 'inactive' },
        { label: 'Deactivated', value: 'deactivated' }

      ],
      Roles: stores.user.roles,
      isSuperAdmin: stores.user.ACL.superAdmin,
      totalCount: 0,
      flag: false,
      flagFranchisee: false,
      flagStatus: false
    }
  },
  created: async function () {
    if (this.isSuperAdmin) {
      await this.getZoneDetails()
    } else {
      await this.getZoneWiseFranchisee()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    }),
    displayedHeaders () {
      return this.headers.filter(header => !header.hidden)
    },
    processedData () {
      return this.students.map((item, index) => {
        const toCamelCase = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '-'

        return {
          srNo: index + 1,
          ...item,
          fullName: item.studentEnrollment
            ? item.studentEnrollment.studentName?.trim()
              ? item.studentEnrollment.studentName
              : '-'
            : '-',
          fatherName: item.studentEnrollment
            ? item.studentEnrollment.fatherName?.trim()
              ? item.studentEnrollment.fatherName
              : '-'
            : '-',
          motherName: item.studentEnrollment
            ? item.studentEnrollment.motherName?.trim()
              ? item.studentEnrollment.motherName
              : '-'
            : '-',
          enrollmentCode: item.studentEnrollment
            ? item.studentEnrollment.enrollmentCode?.trim()
              ? item.studentEnrollment.enrollmentCode
              : '-'
            : '-',
          fatherLogin: item.studentEnrollment
            ? toCamelCase(
              item.studentEnrollment.enquiry.fatherLogin ? item.studentEnrollment.enquiry.fatherLogin : 'Inactive'
            )
            : '-',
          motherLogin: item.studentEnrollment
            ? toCamelCase(
              item.studentEnrollment.enquiry.motherLogin ? item.studentEnrollment.enquiry.motherLogin : 'Inactive'
            )
            : '-'

        }
      })
    },
    totalStudent () {
      return this.processedData.length
    },
    startIndex () {
      return this.totalStudent === 0 ? 0 : (this.page - 1) * this.pageSize + 1
    },
    endIndex () {
      return Math.min(this.page * this.pageSize, this.totalStudent)
    }

  },
  mounted: async function () {
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYearID: async function (val) {
      await this.onFranchiseeChange()
    },
    zoneWiseFranchisees: async function (params) {
      if (this.zoneWiseFranchisees.length !== 0) {
        if (this.zoneWiseFranchisees.length === this.selectedCenterIds.length) {
          this.flagFranchisee = true
        }
      }
    },
    selectedCenterIds: async function (val) {
      this.isWrite = true

      if (this.zoneWiseFranchisees.length !== 0) {
        if (this.zoneWiseFranchisees.length === this.selectedCenterIds.length) {
          this.flagFranchisee = true
        }
      }
    },
    selectedStatus: async function (val) {
      this.isWrite = true
      if (this.selectedStatus.length === 3) {
        this.flagStatus = true
      }
    },
    selectedZones: async function (val) {
      if (this.selectedZones.length > 0) {
        this.getZoneWiseFranchisee()
        this.isWrite = true
      } else {
        this.zoneWiseFranchisees = []
        this.selectedCenterIds = []
        this.flagFranchisee = false
      }
      if (this.selectedZones.length <= 3) {
        this.flagFranchisee = false
      }
      const validRegions = new Set(this.selectedZones.map(zone => zone.name))
      this.selectedCenterIds = this.selectedCenterIds.filter(center => validRegions.has(center.region))

      if (this.selectedZones.length === 4) {
        this.flag = true
      }
    }
  },
  methods: {
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
    },
    handlePageChange (value) {
      this.page = value
      this.isLoading = true
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
    },
    convertToCSV (headers, data) {
      const headerRow = headers.map(header => header.text).join(',')

      const dataRows = data.map(row => {
        return headers.map(header => {
          const keys = header.value.split('.')

          let value = keys.reduce((acc, key) => (acc ? acc[key] : ''), row) || ''

          if (header.text === 'Father Status' && value === '-') {
            value = 'IE App Inactive'
          }
          if (header.text === 'Mother Status' && value === '-') {
            value = 'IE App Inactive'
          }

          if (value === '-' || value === '') {
            return 'NA'
          }
          // Format 'updatedAt' field if it's a valid date
          if (header.value === 'updatedAt' && value) {
            value = moment(value).format('DD-MM-YYYY HH:mm:ss') // Converts to 18-03-2024 06:16:49
          }

          return value
        }).join(',')
      })

      return [headerRow, ...dataRows].join('\n')
    },
    downloadCSV () {
      if (this.students.length === 0) {
        return this.errMsg('Data Not Found!')
      }
      if (this.isWrite) {
        return this.errMsg('Please Click on submit before downloading!')
      }

      const csvContent = this.convertToCSV(this.headers, this.processedData)
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', 'IE App Parents Status Report.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    getZoneDetails: async function () {
      if (this.isSuperAdmin) {
        try {
          this.isLoading = true
          let result = await http.get(
            `${constants.API_URL}/api/curriculum_cms/get-zones`
          )

          this.zones = result.data
          this.isLoading = false
        } catch (e) {
          this.isLoading = false
          const errorMessage =
(e && e.response && e.response.data.message) || e.message
          this.errMsg(errorMessage)
        }
      }
    },
    getZoneWiseFranchisee: async function () {
      try {
        if (!this.isSuperAdmin) {
          this.zoneWiseFranchisees = []
          this.selectedCenter = ''
          const response = await http.get(
            `${constants.API_URL}/api/franchisee/active`
          )
          this.zoneWiseFranchisees = response.data.rows
        } else {
          if (this.selectedZones.length === 0) {
            this.zoneWiseFranchisees = []
            this.flag = false
            this.flagFranchisee = true
            return
          }
          let selectedZone = []
          this.selectedCenter = ''
          this.zoneWiseFranchisees = []

          for (const item of this.selectedZones) {
            selectedZone.push(item.name)
          }
          const data = await http.post(
            `${constants.API_URL}/api/franchisee/get/zone-wise-franchisee`,
            {
              zone: selectedZone
            }
          )
          this.zoneWiseFranchisees = data.data

          if (this.selectedZones.length === 4) {
            this.flagFranchisee = true
            this.allFranchisee()
          }
        }
      } catch (e) {
        const errorMessage =
      (e && e.response && e.response.data.message) || e.message
        console.error(errorMessage)
        return this.errMsg(errorMessage)
      }
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },

    getStudents: async function (fid = this.franchiseeID, status = this.selectedStatus) {
      if (this.selectedCenterIds.length === 0) {
        if (this.isSuperAdmin) {
          if (this.selectedZones.length === 0) {
            return this.errMsg('Please select zone!')
          }
          return this.errMsg('Please select center!')
        } else {
          return this.errMsg('Please select center!')
        }
      }
      let formData = {
      }
      formData.academicYearID = this.academicYear.id
      if (this.selectedCenterIds && this.selectedCenterIds.length > 0) {
        let franId = []
        for (const item of this.selectedCenterIds) {
          franId.push(item.id)
        }
        formData.franchiseeID = franId
      }

      if ((!this.selectedCenterIds || this.selectedCenterIds.length === 0) && this.selectedZones) {
        formData.zone = this.selectedZones.name
      }
      if (this.selectedStatus && this.selectedCenterIds.length > 0) {
        let statusValue = []
        for (const item of this.selectedStatus) {
          statusValue.push(item.value)
        }
        formData.status = statusValue
      }

      if (this.selectedStatus.length === 0) {
        delete formData.status
      }

      try {
        this.isLoading = true
        let url = `${constants.API_URL}/api/fetch/parent-login-status`
        const result = await http.post(url, formData)
        this.students = result.data
        this.totalCount = this.students.length + 1
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.error(errorMessage)
      } finally {
        this.isWrite = false
        this.isLoading = false
      }
    },

    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    resetFilters () {
      this.selectedZones = ''
      this.selectedCenterIds = []
      this.selectedStatus = ''
      this.students = []
      this.flag = false
      this.flagStatus = false
    },
    allZones: function () {
      let zoneArray = []
      if (this.flag === true) {
        this.zones.forEach(obj => {
          zoneArray.push(obj)
        })
        this.flag = true
      }
      this.selectedZones = zoneArray
    },
    removeCheckZone: function () {
      this.flag = false
      return true
    },
    allFranchisee: function () {
      let franchiseeArray = []
      if (this.flagFranchisee === true) {
        this.zoneWiseFranchisees.forEach(obj => {
          franchiseeArray.push(obj)
        })
        this.flagFranchisee = true
      }
      this.selectedCenterIds = franchiseeArray
    },
    removeCheckFranchisee: function () {
      this.flagFranchisee = false
      return true
    },
    allStatus: function () {
      let statusArray = []
      if (this.flagStatus === true) {
        this.statusOptions.forEach(obj => {
          statusArray.push(obj)
        })
        this.flagStatus = true
      }
      this.selectedStatus = statusArray
    },
    removeCheckStatus: function () {
      this.flagStatus = false
      return true
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
.truncated-text {
    cursor: pointer;
}
</style>
